import { accessRole } from "../../../helpers/access_role"
import ErrorAccess from '../../../components/Error/Content/Access'

import IndexView from "./Index/View"
import IndexAdminView from "./IndexAdmin/View"
import IndexAtasanView from "./IndexAtasan/View"
import CreateView from "./Create/View"
import CreateAdminView from "./CreateAdmin/View"
import DetailView from "./Detail/View"
import ApproveView from "./Approve/View"
import ApproveReportView from "./ApproveReport/View"
import UpdateView from "./Update/View"
import UpdateAdminView from "./UpdateAdmin/View"
import ReportView from "./Report/View"
import DetailWFHAllView from "./DetailWFHAll/View"

const RouteView = (props) => {

  const queryParams = new URLSearchParams(props.location.search);
  const _create = queryParams.get('create')
  const _createadmin = queryParams.get('createadmin')
  const _detail = queryParams.get('detail')
  const _update = queryParams.get('update')
  const _updateadmin = queryParams.get('updateadmin')
  const _delete = queryParams.get('delete')
  const _approve = queryParams.get('approve')
  const _approve_report = queryParams.get('approve_report')
  const _print = queryParams.get('print')
  const _report = queryParams.get('report')
  const _list_bawahan = queryParams.get('list_bawahan')
  const _detail_wfhall = queryParams.get('detail_wfhall')

  const userdata = JSON.parse(localStorage.getItem('userdata'));
  console.log('accessRole approve:', accessRole('approve'));
  console.log('uriPath:', window.location.pathname);
  console.log('accessValue:', JSON.parse(sessionStorage.getItem('accessValue')));
  console.log('userdata (localStorage):', userdata);
  console.log('is_atasan (userdata):', userdata?.is_atasan);

  if (_create != null) {
    return accessRole('create') ? <CreateView /> : <ErrorAccess />
  } else if (_createadmin != null) {
    return accessRole('create') ? <CreateAdminView /> : <ErrorAccess />
  } else if (_detail != null) {
    return accessRole('read') ? <DetailView /> : <ErrorAccess />
  } else if (_list_bawahan != null) {
    return accessRole('read') ? <IndexAtasanView /> : <ErrorAccess />
  } else if (_update != null) {
    return accessRole('update') ? <UpdateView /> : <ErrorAccess />
  } else if (_updateadmin != null) {
    return accessRole('update') ? <UpdateAdminView /> : <ErrorAccess />
  } else if (_report != null) {
    return accessRole('update') && localStorage.getItem('currentRoleId') == 2 ? <ReportView /> : <ErrorAccess />
  } else if (_delete != null) {
    return null
  } else if (_approve != null) {
    return accessRole('approve') ? <ApproveView /> : <ErrorAccess />
  } else if (_approve_report != null) {
    return accessRole('update') ? <ApproveReportView /> : <ErrorAccess />
  } else if (_print != null) {
    return null
  } else if (_detail_wfhall != null) {
    if (localStorage.getItem('currentRoleId') == 1) {
      return accessRole('approve') ? <DetailWFHAllView uuid={queryParams.get('uuid')} /> : <ErrorAccess />
    }
    return <ErrorAccess />
  }

  // if (accessRole('approve')) {
  if (localStorage.getItem('currentRoleId') == 1) {
    return accessRole('read') ? <IndexAdminView /> : <ErrorAccess />    
  } else {
    // if(userdata?.is_atasan == 1){
    //   return accessRole('read') ? <IndexAtasanView employee_uuid={userdata?.employee_uuid} /> : <ErrorAccess />
    // } else {
      return accessRole('read') ? <IndexView employee_uuid={userdata?.employee_uuid} /> : <ErrorAccess />
    // }
  }
}
export default RouteView